// Área do cadastro do profissional a que se refere a reprovação. Chave
// fechada de 8 valores (sempre 1 só por reprovação) — mesmo enum usado no
// app do profissional (diag-reactnative). O texto exibido pro admin/usuário
// não vem da API, é definido em presentation/constants/professionalRejectionStepLabels.ts.
export enum EProfessionalRejectionStep {
    PROFESSIONAL_DATA = "professional_data",
    PROFILE = "profile",
    DOCUMENTS = "documents",
    SELFIE = "selfie",
    SPECIALTY = "specialty",
    PRICE = "price",
    WORKING_HOURS = "working_hours",
    PAYOUT_INFO = "payout_info",
}
